class GetArticlesUseCase {
    /**
     * @param {ArticleRepository} articleRepository
     */
    constructor(articleRepository) {
        this.articleRepository = articleRepository;
    }

    /**
     * @param {number} limit
     * @param {string} [startAfterId]
     * @returns {Promise<Article[]>}
     */
    async execute(limit, startAfterId) {
        return this.articleRepository.getArticles(limit, startAfterId);
    }
}

export default GetArticlesUseCase;
